import { gaEvent } from "./ga";
import { SocialIcon, type SocialPlatform } from "./socialIcons";

const SOCIAL_LINKS: { platform: SocialPlatform; label: string; url: string }[] = [
  {
    platform: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/people/Legend-Sports-Cave/61591368136512/",
  },
  { platform: "x", label: "X", url: "https://x.com/LegndSportsCave" },
  { platform: "instagram", label: "Instagram", url: "https://www.instagram.com/legendsportscave/" },
  { platform: "threads", label: "Threads", url: "https://www.threads.com/@legendsportscave" },
  {
    platform: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/legend-sports-cave/",
  },
];

/** Compact public-site social links for the main LSC footer. */
export default function PublicSocialLinks() {
  return (
    <nav aria-label="Follow Legend Sports Cave" className="selector-social-links">
      <span className="selector-social-links__label">Follow LSC</span>
      <div className="selector-social-links__icons">
        {SOCIAL_LINKS.map(({ platform, label, url }) => (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label={`Legend Sports Cave on ${label}`}
            title={label}
            className="selector-social-links__link"
            onClick={() => gaEvent("social_link_click", { platform })}
          >
            <SocialIcon platform={platform} size={17} />
          </a>
        ))}
      </div>
    </nav>
  );
}
